import { Toaster, ToastBar } from 'react-hot-toast';

import styles from './_index.module.scss';

const Notification = () => {
  return (
    <Toaster position="bottom-left" toastOptions={{ className: styles['notification'] }}>
      {(t) => {
        // @ts-ignore - status isn't typed on Toast
        const status = t?.status || 'info';

        return (
          <ToastBar toast={t}>
            {() => (
              <div className={styles['notification-content']}>
                <div className={styles[`is-${status}`]}>
                  {/* @ts-ignore - title isn't typed on Toast */}
                  {t?.title && <h3>{t?.title}</h3>}
                  {t?.message}
                </div>
              </div>
            )}
          </ToastBar>
        );
      }}
    </Toaster>
  );
};

export default Notification;
